<template>
  <div
    class="bg-body"
    :class="{'bg_i6_tp': isThaiCharoenPlus, 'bg_i6_sc': isSevenColor, 'bg_i6_ts': isThaisiam, 'bg_i6_hp': isHuaypromt, 'bg_i6_jj': isJertjarat, 'bg_i6': isDefaultSite}"
  >
    <div class="container-x pb-10 pt-4">
      <div
        style="position: fixed; top: 0px; right: 0px; left: 0px; pointer-events: none; width: auto; height: 3px; opacity: 0; background: repeating-linear-gradient(to right, rgb(0, 220, 130) 0%, rgb(52, 205, 254) 50%, rgb(0, 71, 225) 100%); transform: scaleX(0); transform-origin: left center; transition: transform 0.1s, height 0.4s, opacity 0.4s; z-index: 999999;"
      >
      </div>
      <div
        class="header-navigation flex items-center gap-2 rounded-lg p-2 text-xl mb-4"
        @click="goToHome"
      >
        <a
          class="txt-link bdr-20 animateMe animated fadeInDown"
          data-animation="fadeInDown"
        >
          <i
            class="fas fa-chevron-left me-2 theme-main-text"
          ></i>
          <span
            class="theme-main-text"
          >ย้อนกลับ</span>
          
        </a>
      </div>
      <div
        v-for="item in items"
        :key="item.uuid"
        class="card divide-y mb-6 rule-card"
      >
        <h1
          class="card-title"
        >
          {{ item.title }}
        </h1>
        <div
          class="card-text"
          v-html="item.description"
        >
        </div>
      </div>
    </div>
  </div>
</template>
<script> 
import { anonymous as apiAnonymous } from '@/apis'
import { ROUTE_INDEX } from '@/const/route'


export default { 
  data: () => ({  
    items : [], 
  }),  

  async created () { 
    await this.load() 
  },

  methods : {
    async load () {
      let type = { type : 3 } 
      const [err,data ] = await apiAnonymous.getNews(type) 
      
      if(err) {
        this.$alert('',err,'warning') 
        return
      }     
      this.items = data 
    },

    goToHome () {
      this.$router.push({name: ROUTE_INDEX})
    },
  } 
}
</script>
<style scoped>    
.bg-body {
  /* background-color: white; */
  background-color: var(--bg-secondary-color) !important;
  min-height: 100dvh;
  width: 100%;
}

.container-x {
  margin-left: auto;
  margin-right: auto;
  padding-left: .5rem;
  padding-right: .5rem;
  width: 100%;
  max-width: 90%;
}

.header-navigation #back-btn {
  background: radial-gradient(ellipse at center top, #383838, #171717);
}

.header-navigation {
  cursor: pointer;
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  background-color: rgba(var(--color-primary));
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  position: relative;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}

.btn.icon, [type=button].icon, [type=submit].icon, button.icon {
  height: 2rem;
  min-height: 2rem;
  padding: 0;
  width: 2rem;
}

svg {
  height: 1.25rem;
  width: 1.25rem;
}

.card {
  /* background: radial-gradient(ellipse at center top, #ffd6c2, var(--bg-secondary-color-v2), var(--bg-secondary-color-v2)); */
  background: white;
  border-style: none;
}

.card {
  background-color: #fff;
  border-radius: .5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -4px rgba(0, 0, 0, .1);
  height: auto;
}

.card .card-title {
  align-items: center;
  color: black;
  display: flex;
  font-size: 1.125rem;
  font-weight: 600;
  justify-content: space-between;
  padding: .75rem;
}

.card .card-text {
  color: black;
  padding: .75rem;
}

.card>:not([hidden])~:not([hidden]) {
    border-color: rgba(0, 0, 0, .4);
}

.divide-y>:not([hidden])~:not([hidden]) {
  border-top-width: 1px !important;
  border: 0 solid #e5e7eb;
}

.rule-card {
  padding: 16px;
}
</style>